import React from 'react';
import Flex from 'src/components/Flex';
import styles from './styles.module.scss';
import { TeamWithColor } from 'src/stores/TeamStore';
import Checkbox from 'src/components/Checkbox';

interface Props {
    team: TeamWithColor;
    isChecked: boolean;
    count: number;
    onChange: (b: boolean) => any;
}

function TeamFilterItem(props: Props) {
    return (
        <Flex direction="row" align="center" className={styles.teamItem}>
            <Flex value={1}>
                <Checkbox
                    checked={props.isChecked}
                    onChange={(e) => props.onChange(e.target.checked)}
                    label={props.team.teamName}
                />
            </Flex>
            <Flex
                align="center"
                justify="center"
                className={styles.teamColorBlock}
                style={{ backgroundColor: props.team.color.active }}
            >
                {props.count > 99 ? 99 : props.count}
            </Flex>
        </Flex>
    );
}
export default TeamFilterItem;
